import { Link } from 'react-router-dom';
import { CircleBackslashIcon } from '@radix-ui/react-icons';
import { cn } from '@/lib/utils';

const manageBansClassName = cn(
  'group inline-flex items-center gap-1 border-0 p-0 font-normal shadow-none',
  'bg-transparent !bg-transparent text-xs !text-muted-foreground underline-offset-2',
  'hover:border-transparent hover:bg-transparent hover:!bg-transparent',
  'hover:!text-muted-foreground hover:underline',
  'focus:outline-none focus-visible:bg-transparent focus-visible:outline-none',
  'focus-visible:ring-0 focus-visible:!text-muted-foreground',
);

function ManageBansLabel({ count }: { count: number }) {
  return (
    <>
      <CircleBackslashIcon className="h-3.5 w-3.5" />
      <span>{count} banned</span>
      <span aria-hidden="true">·</span>
      <span className="underline">Manage</span>
    </>
  );
}

export function ManageBansLink({ count, to }: { count: number; to: string }) {
  return (
    <Link to={to} className={manageBansClassName}>
      <ManageBansLabel count={count} />
    </Link>
  );
}

export function ManageBansButton({
  count,
  onClick,
}: {
  count: number;
  onClick: () => void;
}) {
  return (
    <button type="button" onClick={onClick} className={manageBansClassName}>
      <ManageBansLabel count={count} />
    </button>
  );
}
